export const kang_jia = [
  {
    id: 11,
    pid: 0,
    title: '首页',
    name: 'Index',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-s-data',
    url: '/my/tasks',
    sort: 1,
    is_display: 1,
    is_system: 0,
  },
  {
    id: 2,
    pid: 0,
    title: '商品',
    name: 'Goods',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-goods',
    url: '/goods',
    sort: 2,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 8,
        pid: 0,
        title: '商品管理',
        name: 'AllCommodity',
        group_name: 'Goods',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/merchant/allCommodity',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 7,
        pid: 0,
        title: '商品图库',
        name: 'CommodityPictures',
        group_name: 'Goods',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/merchant/commodityPictures',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 9,
        pid: 0,
        title: '商品价格',
        name: 'CommodityPrice',
        group_name: 'Goods',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/merchant/commodityPrice',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
  {
    id: 1,
    pid: 0,
    title: '康家管理',
    name: 'Kangjia',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-goods',
    url: '/manage',
    sort: 1,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 5,
        pid: 0,
        title: '基本信息',
        name: 'BaseInfo',
        group_name: 'Kangjia',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/merchant/baseInfo',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 6,
        pid: 0,
        title: '资质证明',
        name: 'QualificationProof',
        group_name: 'Kangjia',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/merchant/qualificationProof',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
  {
    id: 3,
    pid: 0,
    title: '订单管理',
    name: 'Order',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-shopping-cart-full',
    url: '/orders',
    sort: 3,
    is_display: 1,
    is_system: 0,
    children: [
      {
        title: '预处理订单',
        icon: 'el-icon-circle-plus-outline',
        url: '/pretreatment',
        children: [
          {
            title: '录单',
            icon: 'el-icon-remove-outline',
            url: '',
          },
          {
            title: '货品订单',
            icon: 'el-icon-remove-outline',
            url: '/pretreatment/physical',
          }
        ]
      },
      {
        title: '售后预约',
        icon: 'el-icon-circle-plus-outline',
        url: '/after-sale',
        children: [
          {
            title: '货品售后',
            icon: 'el-icon-remove-outline',
            url: '/after-sale/physical',
          }
        ]
      },
    ],
  },
  {
    title: 'CRM客户管理',
    icon: 'el-icon-s-custom',
    url: '',
  },
  {
    title: '财务管理',
    icon: 'el-icon-coin',
    url: '',
  },
  {
    id: 4,
    title: '系统管理',
    icon: 'el-icon-setting',
    url: '',
    children: [
      {
        title: '基本信息',
        icon: 'el-icon-circle-plus-outline',
        url: '',
        children: [
          {
            title: '资质整理',
            icon: 'el-icon-remove-outline',
            url: '',
          }
        ]
      },
      {
        title: '账号管理',
        icon: 'el-icon-circle-plus-outline',
        url: '',
        children: [
          {
            title: '角色管理',
            icon: 'el-icon-remove-outline',
            url: '',
          },
          {
            title: '权限管理',
            icon: 'el-icon-remove-outline',
            url: '',
          }
        ]
      }
    ]
  }
]

// 代理—————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
export const agent = [
  {
    id: 1,
    pid: 0,
    title: '企业代理管理',
    name: 'EnterpriseAgent',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-goods',
    url: '/agent/enterpriseAgent',
    sort: 1,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 5,
        pid: 0,
        title: '基本信息',
        name: 'Information',
        group_name: 'EnterpriseAgent',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/information',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 6,
        pid: 0,
        title: '资质证明',
        name: 'Qualification',
        group_name: 'EnterpriseAgent',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/qualification',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
  {
    id: 2,
    pid: 0,
    title: '商品管理',
    name: 'Product',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-goods',
    url: '/agent/project',
    sort: 1,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 7,
        pid: 0,
        title: '所有商品',
        name: 'Good',
        group_name: 'Product',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/good',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 8,
        pid: 0,
        title: '我的收藏',
        name: 'Collection',
        group_name: 'Product',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/collection',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
  {
    id: 3,
    pid: 0,
    title: '订单管理',
    name: 'Order',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-shopping-cart-full',
    url: '/agent/orders',
    sort: 3,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 9,
        pid: 0,
        title: '所有订单',
        name: 'OrderAll',
        group_name: 'Order',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/order_all',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
  {
    id: 4,
    pid: 0,
    title: '财务管理',
    name: 'Finance',
    group_name: null,
    group_name_all: [],
    icon: 'el-icon-coin',
    url: '/agent/finance',
    sort: 4,
    is_display: 1,
    is_system: 0,
    children: [
      {
        id: 10,
        pid: 0,
        title: '钱包',
        name: 'Wallet',
        group_name: 'Finance',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/wallet',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 11,
        pid: 0,
        title: '提现',
        name: 'Withdraw',
        group_name: 'Finance',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/withdraw',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
      {
        id: 12,
        pid: 0,
        title: '银行卡管理',
        name: 'CardManagement',
        group_name: 'Finance',
        group_name_all: [],
        icon: 'el-icon-remove-outline',
        url: '/agent/cardManagement',
        sort: 99,
        is_display: 1,
        is_system: 0,
      },
    ],
  },
]
